import { format } from "date-fns";

import { logError } from "./error";

export const MS_PER_SECOND = 1000;
export const SECONDS_PER_MINUTE = 60;

/**
 * Formats a date according to the specified format string
 * @param date - The date to format
 * @param formatString - The format string (using date-fns format)
 * @returns The formatted date string
 */
export const formatDate = (date: Date, formatString: string): string => {
  try {
    return format(date, formatString);
  } catch (error) {
    logError("Error formatting date", error);
    return "";
  }
};

export const formatDurationMmSs = (durationMs: number): string => {
  const totalSeconds = Math.floor(durationMs / MS_PER_SECOND);
  const minutes = Math.floor(totalSeconds / SECONDS_PER_MINUTE);
  const seconds = totalSeconds % SECONDS_PER_MINUTE;

  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};

export const formatDuration = (durationMs: number): string => {
  if (!durationMs || durationMs === 0) {
    return "0m";
  }

  const totalMinutes = Math.round(durationMs / 60000);

  if (totalMinutes < 60) {
    return `${totalMinutes}m`;
  }

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (minutes === 0) {
    return `${hours}h`;
  }

  return `${hours}h ${minutes}m`;
};
